import { Cart } from 'src/types/cart'
import { RegistryDiscount } from 'src/types/registryDiscount'
import css from './CartSummary.styles.scss'
import { CompactCartSummary } from './CompactSummary/CompactSummary'
import { FullSummary } from './FullSummary/FullSummary'

interface CartSummaryProps extends Cart, RegistryDiscount {
  isCompact?: boolean
  totalQuantity?: number
}

export const CartSummary = ({
  isCompact,
  applyRegistryDiscount,
  checkoutTotals,
  isEligibleForRegistryDiscount,
  registryDiscountUsageMessage,
  totalQuantity,
}: CartSummaryProps) => (
  <div className={css.CartSummary}>
    <div className={css.CartSummary__list}>
      {isCompact ? (
        <CompactCartSummary checkoutTotals={checkoutTotals} />
      ) : (
        <FullSummary
          applyRegistryDiscount={applyRegistryDiscount}
          checkoutTotals={checkoutTotals}
          isEligibleForRegistryDiscount={isEligibleForRegistryDiscount}
          registryDiscountUsageMessage={registryDiscountUsageMessage}
          totalQuantity={totalQuantity}
        />
      )}
    </div>
  </div>
)
